"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
exports.FolderClosedIcon = function () { return (react_1.default.createElement("svg", { viewBox: "0 0 16 16" },
    react_1.default.createElement("path", { fill: "#e0aa38", d: "M9.912,1l-3.2,3H0V15H16V1ZM15,14H1V5H15ZM15,4H8.221l2.133-2H15Z" }),
    react_1.default.createElement("rect", { fill: "#f2c973", x: "1", y: "5", width: "14", height: "9" }),
    react_1.default.createElement("polygon", { fill: "#fff", points: "14.853 2 14.826 2 10.34 2 8.207 4 14.826 4 14.853 4 14.994 4 14.994 2 14.853 2" }))); };
//# sourceMappingURL=FolderClosedIcon.js.map